<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let title = "Alerta";
  export let message = "";
  export let button1Label = "Ok";
  export let button2Label = "";
  export let button3Label = "";
  export let button1Action = () => closeDialog();
  export let button2Action = () => closeDialog();
  export let button3Action = () => closeDialog();
  export let entradaTexto;
  export let temInput = false;

  function handleButtonClick(action) { action(); }

  function closeDialog() {
    dispatch("close");
    message = "";
  }
</script>

{#if message !== ""}
  <div class="overlay" on:click|self={closeDialog}>
    <div class="dialog fade-in">

      <div class="dialog-header">
        <span class="dialog-title">{title}</span>
        <button class="btn-close" on:click={closeDialog} aria-label="Fechar">✕</button>
      </div>

      <div class="dialog-body">
        <p>{@html message}</p>
        {#if temInput}
          <input class="input-modern" type="text" bind:value={entradaTexto} />
        {/if}
      </div>

      <div class="dialog-footer">
        {#if button3Label}
          <button class="btn-confirm" on:click={() => handleButtonClick(button3Action)}>
            {button3Label}
          </button>
        {/if}
        {#if button2Label}
          <button class="btn-secondary" on:click={() => handleButtonClick(button2Action)}>
            {button2Label}
          </button>
        {/if}
        {#if button1Label}
          <button class="btn-outline" on:click={() => handleButtonClick(button1Action)}>
            {button1Label}
          </button>
        {/if}
      </div>

    </div>
  </div>
{/if}

<style>
  .overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 2000; padding: 16px;
    backdrop-filter: blur(2px);
  }

  .dialog {
    background: #fff;
    border-radius: 16px;
    width: 100%; max-width: 420px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.15);
    border-top: 5px solid #a1b57d;
    font-family: 'Montserrat', -apple-system, sans-serif;
    overflow: hidden;
  }

  .dialog-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 16px 20px 12px;
    border-bottom: 1px solid #e0e6e2;
  }

  .dialog-title {
    font-weight: 800; font-size: 1rem; color: #a1b57d;
  }

  .btn-close {
    background: rgba(0,0,0,0.06); border: none;
    width: 28px; height: 28px; border-radius: 50%;
    font-size: 0.8rem; cursor: pointer; color: #738a7c;
    display: flex; align-items: center; justify-content: center;
  }
  .btn-close:hover { background: rgba(0,0,0,0.12); }

  .dialog-body {
    padding: 18px 20px;
    font-size: 0.95rem; color: #2c3e34; line-height: 1.6;
  }
  .dialog-body p { margin: 0; }

  .input-modern {
    width: 100%; margin-top: 12px; padding: 10px 14px;
    border: 1px solid #e0e6e2; border-radius: 8px;
    font-size: 0.93rem; background: #f4f7f5;
    font-family: inherit;
  }
  .input-modern:focus {
    outline: none; border-color: #a1b57d;
    box-shadow: 0 0 0 3px rgba(161,181,125,0.15);
  }

  .dialog-footer {
    display: flex; justify-content: flex-end; gap: 8px;
    padding: 12px 20px 18px; flex-wrap: wrap;
  }

  .btn-confirm {
    background: #a1b57d; color: #fff; border: none;
    padding: 10px 20px; border-radius: 8px;
    font-weight: 700; font-size: 0.9rem; cursor: pointer;
    transition: background 0.2s;
  }
  .btn-confirm:hover { background: #8aa864; }

  .btn-secondary {
    background: #6c757d; color: #fff; border: none;
    padding: 10px 20px; border-radius: 8px;
    font-weight: 700; font-size: 0.9rem; cursor: pointer;
    transition: background 0.2s;
  }
  .btn-secondary:hover { background: #565e64; }

  .btn-outline {
    background: transparent; color: #a1b57d;
    border: 2px solid #a1b57d;
    padding: 9px 20px; border-radius: 8px;
    font-weight: 700; font-size: 0.9rem; cursor: pointer;
    transition: 0.2s;
  }
  .btn-outline:hover { background: #f4f8f0; }

  .fade-in { animation: fadeIn 0.25s ease-out; }
  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95) translateY(8px); }
    to   { opacity: 1; transform: scale(1)    translateY(0);   }
  }

  @media (max-width: 480px) {
    .dialog-footer { flex-direction: column-reverse; }
    .btn-confirm, .btn-secondary, .btn-outline { width: 100%; text-align: center; }
  }
</style>
